/**
 * Created by LinChengMing on 2017/10/27.
 */
//crm 经纪人接口
let crmBroker = {
  //测试环境
  baseUrl: 'https://back.jrerdangjia.com:9862',
  //本地环境
  // baseUrl: 'http://192.168.22.178:9888',
//经纪人登录
  login: function () {
    return this.baseUrl + "/broker/login"
  },
  //经纪人注册
  register: function () {
    return this.baseUrl + "/broker"
  },
  //查询登录经纪人的下属客户
  brokerCustomer: function () {
    return this.baseUrl + "/wechat/broker/customer"
  },
  products: function () {
    return this.baseUrl + "/wechat/product";
  },
  addCustomer: function () {
    return this.baseUrl + "/broker/customer";
  },
  updateCustomer: function () {
    return this.baseUrl + "/broker/customer/-1";
  },
  getBroker: function () {
    return this.baseUrl + "/wechat/broker";
  },
  uploadFile: function () {
    return this.baseUrl + "/upload/broker/idcard"
  },
  getFile: function (id) {
    return this.baseUrl + "/archive/" + id;
  }

}
export default {
  crmBroker
}



// WEBPACK FOOTER //
// ./src/baseURL/config.js